function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { stringify } from 'utils/query-string';
import { HttpClient } from 'api/http-client';
import { toastService } from 'components/molecules/toast';
import { getFormattedDateRangeForTimeAnalytics } from 'components/organisms/reports/date-range-utils';
import { TimesheetStatus } from 'components/organisms/timesheets/types';
import { fieldAccessMetaToBase3 } from 'utils/field-access';
import { constructUrl } from 'utils/http-utilts';
import { ApiFilter, ApiGroupFilter } from 'utils/simple-search-filter/simple-search-filter';
import { transformer } from './allocations/entry';
import { entriesFromAllocationsUrl } from './allocations/utils';
import { TimesheetSourcePage } from './types';
export var ApiTimesheetStatus = /*#__PURE__*/ function(ApiTimesheetStatus) {
    ApiTimesheetStatus["NotSubmitted"] = "NOT_SUBMITTED";
    ApiTimesheetStatus["Submitted"] = "SUBMITTED";
    ApiTimesheetStatus["Approved"] = "APPROVED";
    ApiTimesheetStatus["Rejected"] = "REJECTED";
    return ApiTimesheetStatus;
}({});
export var TimesheetEntryType = /*#__PURE__*/ function(TimesheetEntryType) {
    TimesheetEntryType["TaskEntry"] = "TASK_ENTRY";
    TimesheetEntryType["AdhocEntry"] = "ADHOC_ENTRY";
    TimesheetEntryType["Integration"] = "INTEGRATION_ENTRY";
    TimesheetEntryType["ProjectEntry"] = "PROJECT_ENTRY";
    TimesheetEntryType["PhaseEntry"] = "PHASE_ENTRY";
    return TimesheetEntryType;
}({});
export var TimesheetCalendarSourceType = /*#__PURE__*/ function(TimesheetCalendarSourceType) {
    TimesheetCalendarSourceType["GoogleCalendar"] = "GOOGLE_CALENDAR";
    TimesheetCalendarSourceType["OutlookCalendar"] = "OUTLOOK_CALENDAR";
    return TimesheetCalendarSourceType;
}({});
export var TimesheetUISourceType = /*#__PURE__*/ function(TimesheetUISourceType) {
    TimesheetUISourceType["Project"] = "PROJECT";
    TimesheetUISourceType["Task"] = "TASK";
    TimesheetUISourceType["Phase"] = "PHASE";
    TimesheetUISourceType["Adhoc"] = "ADHOC";
    TimesheetUISourceType["GoogleCalendar"] = "GOOGLE_CALENDAR";
    TimesheetUISourceType["OutlookCalendar"] = "OUTLOOK_CALENDAR";
    return TimesheetUISourceType;
}({});
export const getEquivalentStatusForApiStatus = (apiStatus)=>{
    switch(apiStatus){
        case "APPROVED":
            return TimesheetStatus.Approved;
        case "SUBMITTED":
            return TimesheetStatus.Submitted;
        case "NOT_SUBMITTED":
            return TimesheetStatus.NotSubmitted;
        case "REJECTED":
            return TimesheetStatus.Rejected;
        default:
            return TimesheetStatus.NotSubmitted;
    }
};
const asUserTimesheet = (userTimesheets)=>{
    return userTimesheets.map((userTimesheet)=>{
        return {
            ...userTimesheet,
            status: getEquivalentStatusForApiStatus(userTimesheet.status)
        };
    });
};
class TimesheetHttpClient extends HttpClient {
    constructor(...args){
        super(...args), _define_property(this, "getTimesheetForUser", async ({ userId, startDate, projectId, source })=>this.get(`/users/${userId}/timesheets/${startDate}?useNewLogic=true&${stringify({
                projectId,
                sourcePage: source
            }, {
                skipNull: true,
                skipEmptyString: true
            })}`).then((timesheets)=>{
                return asUserTimesheet(timesheets)[0];
            })), _define_property(this, "getTimesheets", async (startDate, filter)=>{
            let matchUrl = '';
            const transformedFilterString = filter ? ApiGroupFilter.toQueryStringFormatForGroups(filter.groupCriteria) : '';
            if (filter === null || filter === void 0 ? void 0 : filter.groupCriteria.length) {
                matchUrl = `&match=${filter === null || filter === void 0 ? void 0 : filter.type}`;
            }
            return this.get(`/timesheets/${startDate}/filter?useNewLogic=true&${transformedFilterString}${matchUrl}`).then((timesheets)=>asUserTimesheet(timesheets));
        }), _define_property(this, "addTimeEntry", async (userId, timeEntry)=>this.post(`/users/${userId}/time-entries`, timeEntry)), _define_property(this, "bulkAddTimeEntry", async (userId, timeEntry)=>this.post(`/users/${userId}/time-entries/bulk-action`, timeEntry)), _define_property(this, "editAdhocTask", async (userId, timeEntries)=>this.post(`/users/${userId}/time-entries/bulk-action`, timeEntries)), _define_property(this, "updateTimeEntry", async (timeEntryId, values)=>this.put(`/time-entries/${timeEntryId}`, values)), _define_property(this, "deleteTimeEntry", async (timeEntryId)=>this.delete(`/time-entries/${timeEntryId}`)), _define_property(this, "deleteTimesheetTask", async (timeEntryIds)=>this.delete(`/time-entries?${timeEntryIds}`)), _define_property(this, "bulkEditTimeEntries", async (userId, editTimeEntyInfo)=>this.put(`/users/${userId}/edit-time-entries/bulk-action`, editTimeEntyInfo)), _define_property(this, "searchTimeEntries", async (filter)=>{
            var _filter_nativeFields, _filter_customFields;
            const fieldsAsQueryString = [
                ...((_filter_nativeFields = filter.nativeFields) !== null && _filter_nativeFields !== void 0 ? _filter_nativeFields : []).map(ApiFilter.nativeFieldToQueryStringFormat),
                ...((_filter_customFields = filter.customFields) !== null && _filter_customFields !== void 0 ? _filter_customFields : []).map(ApiFilter.customFieldToQueryStringFormat)
            ];
            return this.get(`/time-entries/search?${fieldsAsQueryString.join('&')}&${stringify({
                match: fieldsAsQueryString.length > 0 ? filter.match : null
            }, {
                skipNull: true
            })}`);
        }), _define_property(this, "getAllCategories", async ()=>this.get('/timesheets/categories')), _define_property(this, "approveTimesheet", async (userId, startDate, updatedAt, sourcePage, projectId, timeEntryIds)=>this.put(`/users/${userId}/timesheets/${startDate}?useNewLogic=true&lastUpdatedAt=${updatedAt}`, {
                status: "APPROVED",
                timeEntryIds,
                projectId,
                sourcePage
            }).then((timesheets)=>asUserTimesheet(timesheets)[0])), _define_property(this, "approveAllTimesheets", async (startDate, extraFilter, filter, searchValue)=>{
            const transformedFilterString = filter ? ApiGroupFilter.toQueryStringFormatForGroups(filter.groupCriteria) : '';
            return this.put(`/timesheets/${startDate}/approve-all?useNewLogic=true&${transformedFilterString}`, {
                filter: extraFilter,
                search: searchValue,
                sourcePage: TimesheetSourcePage.Approvals
            }).then((timesheets)=>asUserTimesheet(timesheets));
        }), _define_property(this, "submitTimesheet", async (userId, startDate, sourcePage, projectId, timeEntryIds)=>this.put(`/users/${userId}/timesheets/${startDate}?useNewLogic=true`, {
                status: "SUBMITTED",
                projectId,
                timeEntryIds,
                sourcePage
            }).then((timesheets)=>asUserTimesheet(timesheets)[0])), _define_property(this, "rejectTimesheet", async (userId, startDate, updatedAt, sourcePage, content, projectId, timeEntryIds)=>this.put(`/users/${userId}/timesheets/${startDate}?useNewLogic=true&lastUpdatedAt=${updatedAt}`, {
                status: "REJECTED",
                rejectNote: content,
                timeEntryIds,
                projectId,
                sourcePage
            }).then((timesheets)=>asUserTimesheet(timesheets)[0])), _define_property(this, "getActivitiesOfUserInProject", async (userId, projectId)=>projectId ? this.get(`/users/${userId}/time-entries/activities?projectId=${projectId}`) : this.get(`/users/${userId}/time-entries/activities`)), _define_property(this, "withdrawTimesheet", async (userId, startDate, sourcePage, projectId, timeEntryIds)=>this.put(`/users/${userId}/timesheets/${startDate}?useNewLogic=true`, {
                status: "SUBMITTED",
                timeEntryIds,
                projectId,
                sourcePage,
                isApprovalWithdraw: true
            }).then((timesheets)=>asUserTimesheet(timesheets)[0])), _define_property(this, "unsubmitTimesheet", async (userId, startDate, sourcePage, translate, timeEntryIds)=>this.put(`/users/${userId}/timesheets/${startDate}?useNewLogic=true`, {
                status: "NOT_SUBMITTED",
                timeEntryIds,
                sourcePage
            }).then((timesheets)=>asUserTimesheet(timesheets)[0]).catch((error)=>{
                toastService({
                    message: translate('timesheets.failed.unsubmit.time')
                }).error();
                throw error;
            })), _define_property(this, "sendReminder", async (userId, startDate, projectId)=>this.post(projectId ? `/users/${userId}/timesheets/${startDate}/reminders?projectId=${projectId}` : `/users/${userId}/timesheets/${startDate}/reminders`)), _define_property(this, "sendBulkReminder", async (startDate, extraFilter, filter, searchValue)=>{
            const transformedFilterString = filter ? ApiGroupFilter.toQueryStringFormatForGroups(filter.groupCriteria) : '';
            return this.post(`/users/timesheets/${startDate}/remind-all?useNewLogic=true&${transformedFilterString}`, {
                filter: extraFilter,
                search: searchValue
            });
        }), _define_property(this, "getRejectNote", async (userId, startDate)=>this.get(`/users/${userId}/timesheets/${startDate}/note`)), _define_property(this, "getTimeEntriesByIds", async (timeEntryIds)=>{
            return this.get(`/time-entries/by-ids?timeEntryIds=${timeEntryIds}`);
        }), _define_property(this, "getTimeEntryInheritableFieldsInfo", async (projectIds, taskIds, userIds)=>{
            return this.get(`/time-entries/inheritable-field-values?${stringify({
                projectIds: Array.from(projectIds).join(','),
                taskIds: Array.from(taskIds).join(','),
                userIds: Array.from(userIds).join(',')
            }, {
                skipNull: true,
                skipEmptyString: false
            })}`);
        }), _define_property(this, "getTimeEntryFieldAccessMetaInBase3", async ()=>{
            const fieldsAccessMeta = await this.get('/time-entries/field-access-meta');
            return fieldAccessMetaToBase3(fieldsAccessMeta);
        }), _define_property(this, "getTimeEntryAccessFlagsOrder", async ()=>{
            return this.get('/time-entries/access-flags');
        }), _define_property(this, "getTimeEntryPolicyConflicts", async (timeEntryIds)=>{
            // Make sure that wherever this is being called, we are using setTimeout to delay the request by 500ms, becaue backend does the process in async
            return this.get(`time-entries/policy-conflicts/by-ids?timeEntryIds=${timeEntryIds}`);
        }), _define_property(this, "getTimeEntryPolicyConflictsForList", async (filter, calendarEngine, projectId)=>{
            const [startDate, endDate] = getFormattedDateRangeForTimeAnalytics(filter.range, calendarEngine);
            const filterString = ApiGroupFilter.toQueryStringFormatForGroups(filter.groupCriteria);
            const url = constructUrl({
                baseURL: 'time-entries/light/policy-conflicts',
                params: {
                    startDate,
                    endDate,
                    projectId,
                    match: filter.type
                },
                paramsToAddWithoutKeys: [
                    filterString
                ]
            });
            return this.get(url);
        }), _define_property(this, "getRateOverridesCount", ({ projectId, startDate, endDate, budgetId, rateType })=>{
            const url = constructUrl({
                baseURL: '/time-entries/rate-overrides/count',
                params: {
                    projectId,
                    startDate,
                    endDate,
                    budgetId,
                    rateType
                }
            });
            return this.get(url);
        }), _define_property(this, "getAllocationsEntriesPreview", (param)=>{
            if (!param.startDate) {
                return Promise.resolve([]);
            }
            return this.get(entriesFromAllocationsUrl(param)).then((res)=>transformer.toAllocationEntryGroupsWithMeta(res, param.canOverrideDateLock, param.isWeekFreezedAfter));
        });
    }
}
export const TimesheetAPI = new TimesheetHttpClient();
